module.exports = __webpack_public_path__ + "static/media/DSC09524_20180710_038-8.1959758d.jpg";